import { z } from 'zod';

export const GithubStatusSchema = z.object({
	status: z.enum(['connected', 'expired', 'not_connected']),
	selectedOrgs: z.array(z.string()).optional(),
	selectedRepos: z.array(z.string()).optional(),
});
export type GithubStatus = z.infer<typeof GithubStatusSchema>;

export const GithubAuthorizeSchema = z.object({
	redirectUrl: z.string(),
});
export type GithubAuthorize = z.infer<typeof GithubAuthorizeSchema>;

export const GithubDisconnectSchema = z.object({
	disconnected: z.boolean(),
});
export type GithubDisconnect = z.infer<typeof GithubDisconnectSchema>;

export const GithubRepoSchema = z.object({
	fullName: z.string(),
	name: z.string(),
	owner: z.string(),
	ownerType: z.enum(['User', 'Organization']),
	private: z.boolean(),
	description: z.string().nullable(),
});
export type GithubRepo = z.infer<typeof GithubRepoSchema>;

export const GithubReposResponseSchema = z.object({
	repos: z.array(GithubRepoSchema),
	totalCount: z.number(),
});

export const GithubPreferencesSchema = z.object({
	selectedOrgs: z.array(z.string()),
	selectedRepos: z.array(z.string()),
});
export type GithubPreferences = z.infer<typeof GithubPreferencesSchema>;
